module.exports = __webpack_public_path__ + "img/shoushuo.1c870e80.png";